// extracted by mini-css-extract-plugin
module.exports = {"teamContainer":"teams_teamContainer__AgJ2B","teamTitle":"teams_teamTitle__QT66d","customerList":"teams_customerList__zlSB8"};